module.exports = "build/assets/RingsideWide-Semi.aca70d38.woff2";